import { Quadrant, PlateFillingOption } from "./reaction-set-enums";

/**    
  * @author Naveen 
  * @description ReactionPlateQuadrant model 
  */
 export class ReactionPlateQuadrant{

    quadrant:Quadrant;

    fillingOption:PlateFillingOption;

 }
